<script>
import { mapActions } from 'vuex';
import request from '@/services/request';
import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    name: "ModalBankingServicePaymentsComponent",

    components: {
        DatePicker
    },

    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            isView: false,
            send: false,
            ruleInfo: null,
            loadingRule: false,

            form: {
                id: '',
                payable_type_id: 1,
                bank_account_id: '',
                provider_id: '',

                concept: '',
                subtotal: '',
                iva: '',
                amount: '',

                payment_date: '',
                observation: '',
                type_payment_id: '',

                files: [],
            },

            files: [],
        };
    },

    methods: {
        async getRuleInfo() {
            if (!this.form.payable_type_id) {
                this.ruleInfo = null;
                return;
            }

            if (this.form.payable_type_id == 1 && !this.form.bank_account_id) {
                this.ruleInfo = null;
                return;
            }

            if (this.form.payable_type_id == 2 && !this.form.provider_id) {
                this.ruleInfo = null;
                return;
            }

            this.loadingRule = true;

            let _endpoint = '/banking-service-payments/rule-info';

            let params = {
                payable_type_id: this.form.payable_type_id,
                provider_id: this.form.provider_id,
                bank_account_id: this.form.bank_account_id,
                payment_date: this.form.payment_date,
            };

            try {
                let { data } = await request.get(_endpoint, params);

                if (data) {
                    this.ruleInfo = data;
                }
            } catch (error) {
                this.errors = {};

                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            } finally {
                this.loadingRule = false;
            }
        },

        closedModal() {
            this.resetForm();
            this.$modal.hide('addBankingServicePayment');
        },

        resetForm() {
            this.errors = {};
            this.isView = false;
            this.send = false;
            this.ruleInfo = null;
            this.loadingRule = false;

            this.form = {
                id: '',
                payable_type_id: 1,
                bank_account_id: '',
                provider_id: '',

                concept: '',
                subtotal: '',
                iva: '',
                amount: '',

                payment_date: '',
                observation: '',
                type_payment_id: '',

                files: [],
            };

            this.files = [];
        },

        onPayableTypeChange() {
            const type = parseInt(this.form.payable_type_id);

            if (type === 1) {
                this.form.provider_id = '';
            }

            if (type === 2) {
                this.form.bank_account_id = '';
            }

            this.ruleInfo = null;
        },

        toNumber(value) {
            if (value === null || value === undefined || value === '') {
                return 0;
            }

            if (typeof value === 'number') {
                return value;
            }

            let clean = value.toString()
                .replace('$', '')
                .replace(/,/g, '')
                .trim();

            let number = parseFloat(clean);

            return isNaN(number) ? 0 : number;
        },

        roundMoney(value) {
            return Math.round((this.toNumber(value) + Number.EPSILON) * 100) / 100;
        },

        calculateIva() {
            const subtotal = this.roundMoney(this.form.subtotal);
            this.form.iva = this.roundMoney(subtotal * 0.16);
            this.calculateTotal();
        },

        calculateTotal() {
            const subtotal = this.roundMoney(this.form.subtotal);
            const iva = this.roundMoney(this.form.iva);

            this.form.amount = this.roundMoney(subtotal + iva);
        },

        uploadFilesPayment(event) {
            let file = event.target.files[0];

            if (!file) {
                return;
            }

            if ((this.form.files.length + this.files.length) >= 15) {
                this.errorNotification('Solo puedes adjuntar máximo 15 archivos.');
                event.target.value = '';
                return;
            }

            const allowedTypes = [
                'image/jpeg',
                'image/png',
                'application/pdf'
            ];

            if (!allowedTypes.includes(file.type)) {
                this.errorNotification('Solo se permiten archivos JPG, PNG y PDF.');
                event.target.value = '';
                return;
            }

            if (file.size > 5120 * 1024) {
                this.errorNotification('Cada archivo debe pesar máximo 5MB.');
                event.target.value = '';
                return;
            }

            this.form.files.push(file);
            this.$forceUpdate();

            event.target.value = '';
        },

        createURL(file) {
            return URL.createObjectURL(file);
        },

        async delImgUpload(pos) {
            let img = this.files[pos];

            if (!img || !img.id) {
                return;
            }

            let _endpoint = `/banking-service-payments/files/${img.id}`;

            try {
                let dataResponse = null;

                if (typeof request.delete === 'function') {
                    dataResponse = await request.delete(_endpoint);
                } else {
                    dataResponse = await request.post(_endpoint, {
                        _method: 'DELETE'
                    });
                }

                let data = dataResponse.data;

                if (data) {
                    this.successNotification(data.message || 'El archivo se eliminó correctamente.');
                    this.files.splice(pos, 1);
                }
            } catch (error) {
                if (error.response) {
                    await this.errorNotification(error);
                }
            }
        },

        delImg(pos) {
            this.form.files.splice(pos, 1);
            this.successNotification('El archivo se eliminó correctamente.');
        },

        getStoredFileUrl(file) {
            return `${this.globalUrlFiles}${file.file}`;
        },

        getStoredFileName(file) {
            if (!file) {
                return 'Archivo';
            }

            return file.name || file.file || 'Archivo';
        },

        formatBankAccountOption(account) {
            let name = account.name || '';

            if (account.bank) {
                name += ` / ${account.bank.name}`;
            }

            if (account.number) {
                name += ` - ${account.number}`;
            }

            return name;
        },

        formatProviderOption(provider) {
            return `${provider.name || ''} ${provider.last_name || ''}`;
        },

        preparePayload() {
            const type = parseInt(this.form.payable_type_id);

            this.calculateTotal();

            const data_form = new FormData();

            data_form.append('payable_type_id', type || '');

            data_form.append(
                'bank_account_id',
                type === 1 ? (this.form.bank_account_id || '') : ''
            );

            data_form.append(
                'provider_id',
                type === 2 ? (this.form.provider_id || '') : ''
            );

            data_form.append('concept', this.form.concept || '');
            data_form.append('subtotal', this.roundMoney(this.form.subtotal));
            data_form.append('iva', this.roundMoney(this.form.iva));
            data_form.append('amount', this.roundMoney(this.form.amount));

            data_form.append('payment_date', this.form.payment_date || '');
            data_form.append('observation', this.form.observation || '');
            data_form.append('type_payment_id', this.form.type_payment_id || '');

            this.form.files.forEach(function (valor, index) {
                data_form.append('files[' + index + ']', valor);
            });

            return data_form;
        },

        async savePayment() {
            this.send = true;

            let form = this.preparePayload();

            let _endpoint = '/banking-service-payments';

            try {
                let { data } = await request.postMedia(_endpoint, form);

                if (data) {
                    this.successNotification(data.message);
                    this.closedModal();
                    Event.$emit('event-reload-banking-service-payment');
                }
            } catch (error) {
                this.send = false;
                this.errors = {};

                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }
        },

        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },

    watch: {
        'form.subtotal': function () {
            if (!this.isView) {
                this.calculateIva();
            }
        },

        'form.iva': function () {
            this.calculateTotal();
        },

        'form.payment_date': function () {
            if (!this.isView) {
                this.getRuleInfo();
            }
        },
    },

    created() {
        Event.$on('event-show-banking-service-payment', async (payment) => {
            this.resetForm();

            if (payment && payment.id) {
                this.isView = true;

                this.form.id = payment.id;
                this.form.payable_type_id = payment.payable_type_id;
                this.form.bank_account_id = payment.bank_account_id || '';
                this.form.provider_id = payment.provider_id || '';

                this.form.concept = payment.concept || '';
                this.form.subtotal = payment.subtotal || '';
                this.form.iva = payment.iva || '';
                this.form.amount = payment.amount || '';

                this.form.payment_date = payment.payment_date || '';
                this.form.observation = payment.observation || '';
                this.form.type_payment_id = payment.type_payment_id || '';

                this.form.files = [];
                this.files = payment.files || [];
            }

            this.catalogue.get_bank_accounts_rules(1);

            this.$modal.show('addBankingServicePayment');
        });
    },

    mounted() {
        this.catalogue.get_type_payments();
    },
};
</script>

<template>
    <modal v-bind:click-to-close="false" name="addBankingServicePayment" :width="'80%'" :height="'auto'">
        <form @submit.prevent="savePayment" method="post" enctype="multipart/form-data">
            <button type="button" class="btn btn-danger btn-sm btn-closed" :disabled="send" @click="closedModal()">
                <i class="fa-solid fa-xmark"></i>
            </button>

            <div class="modal-header">
                <h5 class="modal-title">
                    Pago de servicio bancario
                </h5>
            </div>

            <div class="modal-body">
                <div class="row">

                    <div class="col-md-6">
                        <label>Tipo</label>
                        <select class="form-control" v-model="form.payable_type_id" @change="onPayableTypeChange"
                            disabled="disabled">
                            <option value="">Selecciona tipo</option>
                            <option :value="1">Cuenta bancaria</option>
                            <option :value="2">Proveedor</option>
                        </select>

                        <div v-if="errors && errors.payable_type_id" class="text-danger">
                            {{ errors.payable_type_id[0] }}
                        </div>
                    </div>

                    <div v-if="parseInt(form.payable_type_id) === 1" class="col-md-6">
                        <label>Cuenta bancaria</label>
                        <select class="form-control" v-model="form.bank_account_id" :disabled="isView"
                            @change="getRuleInfo">
                            <option value="">Selecciona cuenta bancaria</option>

                            <option v-for="(account, index) in catalogue.bank_accounts_rules" :key="index"
                                :value="account.id">
                                {{ formatBankAccountOption(account) }}
                            </option>
                        </select>

                        <div v-if="errors && errors.bank_account_id" class="text-danger">
                            {{ errors.bank_account_id[0] }}
                        </div>
                    </div>

                    <div v-if="parseInt(form.payable_type_id) === 2" class="col-md-6">
                        <label>Proveedor</label>
                        <select class="form-control" v-model="form.provider_id" :disabled="isView"
                            @change="getRuleInfo">
                            <option value="">Selecciona proveedor</option>

                            <option v-for="(provider, index) in catalogue.users_profiles" :key="index"
                                :value="provider.id">
                                {{ formatProviderOption(provider) }}
                            </option>
                        </select>

                        <div v-if="errors && errors.provider_id" class="text-danger">
                            {{ errors.provider_id[0] }}
                        </div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Concepto</label>
                        <input type="text" class="form-control" v-model="form.concept" :disabled="isView"
                            placeholder="Escribe el concepto del pago">

                        <div v-if="errors && errors.concept" class="text-danger">
                            {{ errors.concept[0] }}
                        </div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Subtotal</label>
                        <money
                            class="form-control"
                            v-model="form.subtotal"
                            :disabled="isView"
                        ></money>

                        <div v-if="errors && errors.subtotal" class="text-danger">
                            {{ errors.subtotal[0] }}
                        </div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>IVA</label>
                        <money
                            class="form-control"
                            v-model="form.iva"
                            :disabled="isView"
                        ></money>

                        <small class="text-muted">
                            Se calcula automático al capturar subtotal, pero puedes editarlo o borrarlo.
                        </small>

                        <div v-if="errors && errors.iva" class="text-danger">
                            {{ errors.iva[0] }}
                        </div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Total</label>
                        <money class="form-control" v-model="form.amount" disabled="disabled"></money>

                        <span v-if="ruleInfo && ruleInfo.rule" class="text-info">
                            Monto máximo por movimiento:
                            {{ ruleInfo.rule.max_amount_per_payment | toCurrency }}
                        </span>

                        <div v-if="errors && errors.amount" class="text-danger">
                            {{ errors.amount[0] }}
                        </div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Fecha de pago</label>
                        <date-picker v-model="form.payment_date" :disabled="isView" valueType="format"></date-picker>

                        <div v-if="errors && errors.payment_date" class="text-danger">
                            {{ errors.payment_date[0] }}
                        </div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Tipo de pago</label>
                        <select class="form-control" v-model="form.type_payment_id" :disabled="isView">
                            <option value="">Selecciona tipo de pago</option>

                            <option v-for="(typePayment, index) in catalogue.type_payments" :key="index"
                                :value="typePayment.id">
                                {{ typePayment.name }}
                            </option>
                        </select>

                        <div v-if="errors && errors.type_payment_id" class="text-danger">
                            {{ errors.type_payment_id[0] }}
                        </div>
                    </div>

                    <div class="col-md-12 mt-2">
                        <label>Observación</label>
                        <textarea class="form-control" rows="3" v-model="form.observation" :disabled="isView"
                            placeholder="Escribe una observación"></textarea>

                        <div v-if="errors && errors.observation" class="text-danger">
                            {{ errors.observation[0] }}
                        </div>
                    </div>

                    <div class="col-12">
                        <hr>

                        <div class="row">
                            <div class="col-12 text-center">
                                <h3>Archivos adjuntos</h3>
                                <p>Máximo 15 archivos. Formatos permitidos: JPG, PNG y PDF.</p>

                                <div class="row mt-4 mb-4">
                                    <div class="col-12" v-if="(form.files.length + files.length) == 0">
                                        <i class="fa-solid fa-file fa-4x"></i>
                                        <p>Sin archivos adjuntos</p>
                                    </div>

                                    <div class="col-md-4 col-12 p-2" v-for="(fAdd, index_fAdd) in files"
                                        :key="'saved-file-' + index_fAdd" v-show="files.length > 0">
                                        <div class="card shadow">
                                            <button v-if="!isView" class="btn btn-sm btn-danger del" type="button"
                                                @click="delImgUpload(index_fAdd)">
                                                <i class="fa fa-trash"></i>
                                            </button>

                                            <div class="card-body text-center">
                                                <a :href="getStoredFileUrl(fAdd)" target="_blank">
                                                    <i class="fa fa-file fa-4x"></i>
                                                    <p>{{ getStoredFileName(fAdd) }}</p>
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-4 col-12 p-2" v-for="(img, index_img) in form.files"
                                        :key="'new-file-' + index_img" v-show="form.files.length > 0">
                                        <div class="card shadow">
                                            <button v-if="!isView" class="btn btn-sm btn-danger del" type="button"
                                                @click="delImg(index_img)">
                                                <i class="fa fa-trash"></i>
                                            </button>

                                            <div class="card-body text-center">
                                                <a :href="createURL(img)" target="_blank">
                                                    <i class="fa fa-file fa-4x"></i>
                                                    <p>{{ img.name }}</p>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="input-group mb-3"
                                    v-if="(form.files.length + files.length) <= 14 && !isView">
                                    <div class="custom-file" @change="uploadFilesPayment">
                                        <input type="file" class="custom-file-input" id="inputGroupFilePayment"
                                            aria-describedby="inputGroupFilePayment" accept=".jpg,.jpeg,.png,.pdf">
                                        <label class="custom-file-label" for="inputGroupFilePayment">
                                            Subir Archivo
                                        </label>
                                    </div>
                                </div>

                                <div v-if="errors && errors.files" class="text-danger">
                                    {{ errors.files[0] }}
                                </div>

                                <div v-if="errors && errors['files.0']" class="text-danger">
                                    {{ errors['files.0'][0] }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="errors && errors.rules" class="col-md-12 mt-3">
                        <div class="text-danger">
                            {{ errors.rules[0] }}
                        </div>
                    </div>

                    <div v-if="ruleInfo && ruleInfo.rule" class="col-md-12 mt-3">
                        <div class="row">
                            <div class="col-md-6 text-center">
                                <label>Monto máximo por mes</label><br>
                                <h5>
                                    <span class="badge badge-secondary">
                                        {{ ruleInfo.rule.max_amount_per_month | toCurrency }}
                                    </span>
                                </h5>
                            </div>

                            <div class="col-md-6 text-center">
                                <label>Movimientos máximo por mes</label><br>
                                <h5>
                                    <span class="badge badge-secondary">
                                        {{ ruleInfo.rule.payments_per_month }}
                                    </span>
                                </h5>
                            </div>
                        </div>

                        <div class="text-info">
                            {{ ruleInfo.rule.description }}
                        </div>
                    </div>

                    <div v-if="typeof errors === 'string'" class="col-md-12 mt-3">
                        <div class="alert alert-danger">
                            {{ errors }}
                        </div>
                    </div>

                    <div class="col-md-12">
                        <hr>

                        <button v-if="!isView" type="submit" :disabled="send"
                            class="btn float-right btn-outline-success">
                            <span v-if="send">
                                <i class="fa-solid fa-circle-notch fa-spin"></i>
                                Guardando
                            </span>

                            <span v-else>
                                <i class="fas fa-save"></i>
                                Guardar
                            </span>
                        </button>

                        <button type="button" :disabled="send" @click="closedModal()"
                            class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>

                </div>
            </div>
        </form>
    </modal>
</template>

<style scoped>
.del {
    position: absolute;
    right: 0px;
    margin: 10px;
    z-index: 10;
}
</style>